import { isCacheable, scopeOf, cachedFetch } from "@/utils/fetchCache";
export const state = () => ({
  per_page: 30,
  rowsPerPageItems: [15, 30, 50],
  config: {},
  products: [],
  allProducts: [],
  hardwareProducts: {
    data: [],
    total: 0,
    current_page: 1,
    per_page: 30,
    from: 0,
    to: 0,
  },
  category: [],
  productSizes: [],
  customers: [],
  history: [],
  expense: [],
  expired: [],
  summary: [],
  orders: [],
  stores: [],
  feedback: [],
  summaryDetails: [],
  summaryBestSeller: [],
  notifyProducts: [],
  expiredProducts: [],
  overdueProducts: [],
  bestSales: [],
  sortProducts: [],
  sizes: [],
  stocks: [],
  billReports: [],
  discountVoidRefundReports: [],
  paymentId: 1,
  discount_type: [
    {
      icon: "money-bill",
      value: "amount",
    },
    {
      icon: "percent",
      value: "percentage",
    },
  ],
  roles: [],
  users: {
    data: [],
    total: 0,
    current_page: 1,
    per_page: 15,
  },
  deletedUsers: {
    data: [],
    total: 0,
    current_page: 1,
    per_page: 15,
  },
  reportUsers: [],
  productStores: [],
  barcode: [],
  reportCategories: [],
  reportCustomers: [],
  mySale: {},
  reportUserSale: [],
  suppliers: [],
  toppings: { data: [], total: 0, current_page: 1, per_page: 15 },
  packages: [],
  branches: [],
  orders: [],
  trash: [],
  product_purchase: [],
  product_barcode: [],
  tables: [],
  overlay: false,
  quotations: [],
  newQuotation: {},
  currencies: [
    {
      name: "LAK",
      symbol: "₭",
    },
    {
      name: "USD",
      symbol: "$",
    },
    {
      name: "THB",
      symbol: "฿",
    },
  ],
  productOptions: [],
  ingredients: { data: [], total: 0, current_page: 1, per_page: 15 },
  account: {
    bankLaName: "ທະນາຄານ ການຄ້າຕ່າງປະເທດລາວ ມະຫາຊົນ",
    bankEnName: "Banque Pour Le Commerce Exterieur Lao Public",
    name: "VONGKEO KEOSAVANH",
    number: "092-12-13357515",
    currency: "LAK",
  },
  logistics: [],
  provinces: [],
  districts: [],
  villages: [],
  activeCurrencies: [],
  customer_id: null,
  selectedCategoryId: 0,
  autoHideDrawer: ["/sale", "/table", "/mobile/table", "/scan/", "/products","/report-bill"],
  activeShift: null, // Current user's active shift
  shiftsList: [], // List of shifts
  shiftStatistics: {}, // Shift statistics
});
export const getters = {
  config: (state) => state.config,
  barcode: (state) => state.barcode,
  suppliers: (state) => state.suppliers,
  productOptions: (state) => state.productOptions,
  ingredients: (state) => state.ingredients,
  toppings: (state) => state.toppings,
  reportUserSale: (state) => state.reportUserSale,
  mySale: (state) => state.mySale,
  reportCategories: (state) => state.reportCategories,
  reportCustomers: (state) => state.reportCustomers,
  productStores: (state) => state.productStores,
  reportUsers: (state) => state.reportUsers,
  users: (state) => state.users,
  deletedUsers: (state) => state.deletedUsers,
  per_page: (state) => state.per_page,
  rowsPerPageItems: (state) => state.rowsPerPageItems,
  per_page_options: (state) => state.rowsPerPageItems,
  billReports: (state) => state.billReports,
  discountVoidRefundReports: (state) => state.discountVoidRefundReports,
  stocks: (state) => state.stocks,
  sortProducts: (state) => state.sortProducts,
  sizes: (state) => state.sizes,
  bestSales: (state) => state.bestSales,
  allProducts: (state) => state.allProducts,
  hardwareProducts: (state) => state.hardwareProducts,
  category: (state) => state.category,
  productSizes: (state) => state.productSizes,
  products: (state) => state.products,
  customers: (state) => state.customers,
  expense: (state) => state.expense,
  discount_type: (state) => state.discount_type,
  history: (state) => state.history,
  summary: (state) => state.summary,
  summaryDetails: (state) => state.summaryDetails,
  summaryBestSeller: (state) => state.summaryBestSeller,
  orders: (state) => state.orders,
  expired: (state) => state.expired,
  stores: (state) => state.stores,
  feedback: (state) => state.feedback,
  notifyProducts: (state) => state.notifyProducts,
  overdueProducts: (state) => state.overdueProducts,
  roles: (state) => state.roles,
  paymentId: (state) => state.paymentId,
  expiredProducts: (state) => state.expiredProducts,
  packages: (state) => state.packages,
  branches: (state) => state.branches,
  orders: (state) => state.orders,
  trash: (state) => state.trash,
  product_purchase: (state) => state.product_purchase,
  product_barcode: (state) => state.product_barcode,
  tables: (state) => state.tables,
  overlay: (state) => state.overlay,
  quotations: (state) => state.quotations,
  newQuotation: (state) => state.newQuotation,
  currencies: (state) => state.currencies,
  account: (state) => state.account,
  activeShift: (state) => state.activeShift,
  shiftsList: (state) => state.shiftsList,
  shiftStatistics: (state) => state.shiftStatistics,
  logistics: (state) => state.logistics,
  provinces: (state) => state.provinces,
  districts: (state) => state.districts,
  villages: (state) => state.villages,
  activeCurrencies: (state) => state.activeCurrencies,
  customer_id: (state) => state.customer_id,
  selectedCategoryId: (state) => state.selectedCategoryId,
  autoHideDrawer: (state) => state.autoHideDrawer,
};

export const mutations = {
  SET_PER_PAGE(state, data) {
    state.per_page = data;
  },
  SET_ROWS_PER_PAGE_ITEMS(state, data) {
    state.rowsPerPageItems = data;
  },
  SET_CONFIG(state, data) {
    state.config = data;
  },
  SET_REPORT_CATEGORIES(state, data) {
    state.reportCategories = data;
  },
  SET_PRODUCT_BARCODE(state, data) {
    state.product_barcode = data;
  },
  SET_USER_SALE(state, data) {
    state.reportUserSale = data;
  },
  SET_MY_SALE(state, data) {
    state.mySale = data;
  },
  SET_REPORT_CUSTOMERS(state, data) {
    state.reportCustomers = data;
  },
  SET_BAR_CODE(state, data) {
    state.barcode.push(data);
  },
  SET_PRODUCT_STORES(state, data) {
    state.productStores = data;
  },

  SET_PRODUCT_SIZE(state, data) {
    state.productSizes = data;
  },

  SET_REPORT_USERS(state, data) {
    state.reportUsers = data;
  },
  SET_PRODUCT_PURCHASE(state, data) {
    state.product_purchase = data;
  },
  SET_USERS(state, data) {
    state.users = data;
  },
  SET_ROLES(state, data) {
    state.roles = data;
  },
  SET_BILL_REPORT(state, payload) {
    state.billReports = payload;
  },
  SET_DISCOUNT_VOID_REFUND_REPORT(state, payload) {
    state.discountVoidRefundReports = payload;
  },
  SET_EXPIRED_PRODUCTS(state, payload) {
    state.expiredProducts = payload;
  },
  SET_STOCKS(state, payload) {
    state.stocks = payload;
  },
  SET_SIZES(state, payload) {
    state.sizes = payload;
  },
  SET_SORT_PRODUCTS(state, payload) {
    state.sortProducts = payload;
  },
  SET_BEST_SALE(state, payload) {
    state.bestSales = payload;
  },
  SET_OVERDUE(state, payload) {
    state.overdueProducts = payload;
  },
  SET_NOTIFY(state, payload) {
    state.notifyProducts = payload;
  },
  SET_EXPIRED(state, payload) {
    state.expired = payload;
  },
  SET_FEEDBACK(state, payload) {
    state.feedback = payload;
  },
  SET_STORES(state, payload) {
    state.stores = payload;
  },
  SET_ORDER(state, payload) {
    state.orders = payload;
  },
  SET_PRODUCT(state, payload) {
    state.products = payload;
  },
  SET_ALL_PRODUCTS(state, payload) {
    state.allProducts = payload;
  },
  SET_HARDWARE_PRODUCTS(state, payload) {
    state.hardwareProducts = payload;
  },
  UPDATE_PRODUCT_IN_LIST(state, updatedProduct) {
    if (state.allProducts && state.allProducts.data) {
      // Paginated response structure
      const index = state.allProducts.data.findIndex(
        (p) => p.id === updatedProduct.id,
      );
      if (index !== -1) {
        state.allProducts.data[index] = {
          ...state.allProducts.data[index],
          ...updatedProduct,
        };
      }
    } else if (Array.isArray(state.allProducts)) {
      // Direct array structure
      const index = state.allProducts.findIndex(
        (p) => p.id === updatedProduct.id,
      );
      if (index !== -1) {
        state.allProducts[index] = {
          ...state.allProducts[index],
          ...updatedProduct,
        };
      }
    }
  },
  SET_TRASH(state, payload) {
    state.trash = payload;
  },
  SET_REPORT_DETAILS(state, payload) {
    state.summaryDetails = payload;
  },
  SET_BEST_SELLER(state, payload) {
    state.summaryBestSeller = payload;
  },
  SET_SUMMARY(state, payload) {
    state.summary = payload;
  },
  SET_PAYMENT(state, payload) {
    state.paymentId = payload;
  },
  SET_PACKAGE(state, payload) {
    state.packages = payload;
  },
  SET_HISTORY(state, payload) {
    state.history = payload;
  },
  SET_ORDER(state, payload) {
    state.orders = payload;
  },
  SET_CATEGORY(state, payload) {
    state.category = payload;
  },
  SET_CUSTOMER(state, payload) {
    state.customers = payload;
  },
  SET_EXPENSE(state, payload) {
    state.expense = payload;
  },
  SET_SUPPLIERS(state, payload) {
    state.suppliers = payload;
  },
  SET_TOPPINGS(state, payload) {
    state.toppings = payload;
  },
  SET_BRANCHES(state, payload) {
    state.branches = payload;
  },
  SET_TABLES(state, payload) {
    state.tables = payload;
  },
  SET_OVERLAY(state, payload) {
    state.overlay = payload;
  },
  SET_QUOTATIONS(state, payload) {
    state.quotations = payload;
  },
  SET_NEW_QUOTATION(state, payload) {
    state.newQuotation = payload;
  },

  SET_PRODUCT_OPTIONS(state, payload) {
    state.productOptions = payload;
  },
  SET_INGREDIENTS(state, payload) {
    state.ingredients = payload;
  },
  SET_LOGISTICS(state, payload) {
    state.logistics = payload;
  },
  SET_PROVINCES(state, payload) {
    state.provinces = payload;
  },
  SET_DISTRICTS(state, payload) {
    state.districts = payload;
  },
  SET_VILLAGES(state, payload) {
    state.villages = payload;
  },
  SET_ACTIVE_CURRENCY(state, payload) {
    state.activeCurrencies = payload;
  },
  SET_CUSTOMER_ID(state, payload) {
    state.customer_id = payload;
  },
  SET_DELETED_USERS(state, payload) {
    state.deletedUsers = payload;
  },
  SET_SELECTED_CATEGORY_ID(state, payload) {
    state.selectedCategoryId = payload;
  },
  SET_ACTIVE_SHIFT(state, payload) {
    state.activeShift = payload;
  },
  SET_SHIFTS_LIST(state, payload) {
    state.shiftsList = payload;
  },
  SET_SHIFT_STATISTICS(state, payload) {
    state.shiftStatistics = payload;
  },
};
export const actions = {
  async fetch(context, { commit, url, that }) {
    try {
      if (isCacheable(url)) {
        const scope = scopeOf(
          context.rootGetters["auth/token"],
          context.rootGetters["auth/user"]
        );
        const result = await cachedFetch(scope, url, async () => {
          const { data } = await that.$http.get(url);
          return data.status ? data.data : undefined;
        });
        if (result !== undefined) await context.commit(commit, result);
        return;
      }
      const { data } = await that.$http.get(url);
      if (data.status) {
        await context.commit(commit, data.data);
      }
    } catch (error) {
      console.error("fetch ", error);
    }
  },
  async fetchActiveCurrencies(context, that) {
    const body = {
      url: `get_all_currencies?active_only=true`,
      that,
      commit: "SET_ACTIVE_CURRENCY",
    };
    //  call fetch function
    await context.dispatch("fetch", body);
  },

  async fetchLogistics(context, that) {
    const body = {
      url: "get_logistics",
      that,
      commit: "SET_LOGISTICS",
    };
    await context.dispatch("fetch", body);
  },
  async fetchProvinces(context, that) {
    const body = {
      url: "provinces",
      that,
      commit: "SET_PROVINCES",
    };
    await context.dispatch("fetch", body);
  },
  async fetchDistricts(context, { that, pr_id }) {
    const body = {
      url: `districts/${pr_id}`,
      that,
      commit: "SET_DISTRICTS",
    };
    await context.dispatch("fetch", body);
  },

  async fetchVillages(context, { that, dr_id }) {
    const body = {
      url: `villages/${dr_id}`,
      that,
      commit: "SET_VILLAGES",
    };
    await context.dispatch("fetch", body);
  },

  /**
   * Fetch current user's active shift
   * GET /my-active-shift
   */
  async fetchActiveShift(context, that) {
    try {
      const { data } = await that.$http.get("my-active-shift");
      if (data.status) {
        await context.commit("SET_ACTIVE_SHIFT", data.data);
      } else {
        // No active shift
        await context.commit("SET_ACTIVE_SHIFT", null);
      }
    } catch (error) {
      // If error (e.g., 404), set to null
      await context.commit("SET_ACTIVE_SHIFT", null);
      console.error("fetchActiveShift error:", error);
    }
  },
};
export const strict = false;
